import { render } from "./UploadAnalisis.vue?vue&type=template&id=5ecb3ff5"
import script from "./UploadAnalisis.vue?vue&type=script&lang=js"
export * from "./UploadAnalisis.vue?vue&type=script&lang=js"

import exportComponent from "D:\\www\\siujilab\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__